import { watch, onBeforeUnmount } from 'vue'

// Every overlay that hides the page shares one body lock: closing one must not
// unlock the page while another is still open.
const holders = new Set()

function lock() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
  document.body.style.paddingRight = `${scrollbarWidth}px`
  document.body.classList.add('overflow-hidden')
}

function unlock() {
  document.body.style.paddingRight = ''
  document.body.classList.remove('overflow-hidden')
}

export default function useScrollLock(isLocked) {
  const token = Symbol('scroll-lock')
  // Callers release from both a watch and onBeforeUnmount, so a second
  // release must not drop someone else's lock.
  let held = false

  const acquire = () => {
    if (held) return
    held = true
    holders.add(token)
    if (holders.size === 1) lock()
  }

  const release = () => {
    if (!held) return
    held = false
    holders.delete(token)
    if (!holders.size) unlock()
  }

  watch(isLocked, (locked) => {
    if (locked) acquire()
    else release()
  }, { immediate: true })

  onBeforeUnmount(release)
}
